import config from './config.js'

function dateFormat(val) {
  if (!val) {
    return ''
  } else {
    const s = (Number(val) - 621355968000000000) / 10000
    const date = new Date(s)
    let month = date.getMonth() + 1
    let day = date.getDate()
    return date.getFullYear() + '-' + (month > 9 ? month : '0' + month) + '-' + (day > 9 ? day : '0' + day)
  }
}

function dateTimeFormat(val) {
  if (!val) {
    return ''
  } else {
    const s = (Number(val) - 621355968000000000) / 10000
    const date = new Date(s)
    let month = date.getMonth() + 1
    let day = date.getDate()
    let hour = date.getHours()
    let min = date.getMinutes()
    return date.getFullYear() + '-' + (month > 9 ? month : '0' + month) + '-' + (day > 9 ? day : '0' + day) + ' ' + (hour > 9 ? hour : '0' + hour) + ':' + (min > 9 ? min : '0' + min)
    //	':' + date.getSeconds()
  }
}

function formatDate(date) {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始的，所以+1，并确保两位数
  const day = date.getDate().toString().padStart(2, '0'); // 确保两位数
  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
}

function timespantodatetime(value) {
  var unixTimestamp = new Date(value * 1000)
  var commonTime = unixTimestamp.toLocaleString()
  return commonTime
}

const minute = 1000 * 60
const hour = minute * 60
const day = hour * 24
const week = day * 7
const month = day * 30

function timeStringFormat(val) {
  var time1 = new Date().getTime() //当前的时间戳
  const s = (Number(val) - 621355968000000000) / 10000
  const time2 = new Date(s).getTime()
  var time = time1 - time2

  var result = null
  if (time < 0) {
    return dateFormat(val)
  } else if (time / month >= 1) {
    //result = parseInt(time / month) + "月前";
    return dateFormatWithOutYear(val)
  } else if (time / week >= 1) {
    //result = parseInt(time / week) + "周前";
    return dateFormatWithOutYear(val)
  } else if (time / day >= 1) {
    result = parseInt(time / day) + '天前'
  } else if (time / hour >= 1) {
    result = parseInt(time / hour) + '小时前'
  } else if (time / minute >= 1) {
    result = parseInt(time / minute) + '分钟前'
  } else {
    result = '刚刚'
  }
  return result
}

function boolFormat(val) {
  if (val) {
    return '是'
  } else {
    return '否'
  }
}

function checkNumber(theObj) {
  if (theObj == '' || theObj == '-')
    return false;
  var reg = /^[+-]?\d*(\.\d*)?(e[+-]?\d+)?$/
  if (reg.test(theObj)) {
    return true
  }
  return false
}


export function getFileType(file) {
  if (!file)
    return null;
  var images = ['jpg', 'jpeg', 'gif', 'png'];
  var videos = ['mp4', 'wmv', 'avi', 'mov'];
  let ary = file.split('.')
  let name = ary[ary.length - 1]
  name = name.toLowerCase()
  if (images.includes(name)) {
    return config.fileTypes[0]
  }
  if (videos.includes(name)) {
    return config.fileTypes[1]
  }
  return null
}

function responseUrlFormat(url, t, type = 'download') {
  let str = decodeURI(url).replace(/\\/g, '/');
  if (t) {
    return `${import.meta.env.VITE_APP_API_URL}${type}?t=${t}&p=${str}`
  } else {
    return `${import.meta.env.VITE_APP_API_URL}${type}?p=${str}`
  }
}

function organizationTypeFormat(val) {
  if (val == null || val == undefined)
    return '';
  return config.organizationType.find((r) => r.value === val || r.key === val).name
}

function positionFormat(val) {
  if (val == null || val == undefined)
    return '';
  return config.position.find((r) => r.value === val || r.key === val).name
}

function genderFormat(val) {
  if (val == null || val == undefined)
    return '';
  return config.gender.find((r) => r.value === val || r.key === val).name
}

function ScheduleTypeFormat(val) {
  if (val == null || val == undefined)
    return '';
  return config.ScheduleType.find((r) => r.value === val || r.key === val).name
}

function RunningModeFormat(val) {
  if (val == null || val == undefined)
    return '';
  return config.RunningMode.find((r) => r.value === val || r.key === val).name
}

function LoggingLevelFormat(val) {
  if (val == null || val == undefined)
    return '';
  return config.LoggingLevel.find((r) => r.value === val || r.key === val).name
}

function paymentModeFormat(val) {
  if (val == null || val == undefined)
    return '';
  return config.paymentMode.find((r) => r.value === val || r.key === val).name
}

function getPaymentStatusTag(val) {
  if (val == 1000) {
    return 'danger';
  }
  if (val == 5000) {
    return 'success';
  }
  if (val == 6000) {
    return 'warning';
  }
  return 'info'
}

function paymentStatusFormat(val) {
  if (val == null || val == undefined)
    return '';
  return config.paymentStatus.find((r) => r.value === val || r.key === val).name
}

function paymentPurposeFormat(val) {
  if (val == null || val == undefined)
    return '';
  return config.paymentPurpose.find((r) => r.value === val || r.key === val).name
}



function productShelfStatusFormat(val) {
  if (val == null || val == undefined)
    return '';
  return config.productShelfStatus.find((r) => r.value === val || r.key === val).name
}

function orderStatusFormat(type, val) {
  if (val == null || val == undefined)
    return '';
  if (val == 2000 || val == 3000) {
    if (type == 1 || type == 'Service') {
      if (val == 2000) {
        return '待派单'
      }
      if (val == 3000) {
        return '已派单'
      }
    }
    else {
      if (val == 2000) {
        return '待发货'
      }
      if (val == 3000) {
        return '已发货'
      }
    }
  }
  return config.orderStatus.find((r) => r.value === val || r.key === val).name;
}

function orderDetailStatusFormat(row) {
  if (row.Order.Type == 1) {
    if (row.Status == 2000) {
      return '待派单';
    }
    if (row.Status == 3000 && !row.Technician.Key) {
      return '待施工';
    }
    if (row.Status == 3000 && row.Technician.Key) {
      return '已施工';
    }
    if (row.Status == 6000) {
      return '已确认';
    }
  }
  if (row.Order.Type == 0) {
    if (row.Status == 2000) {
      return '待发货';
    }
    if (row.Status == 3000) {
      return '已发货';
    }
    if (row.Status == 6000) {
      return '已收货';
    }
  }
  return orderStatusFormat(row.Order.Type, row.Status);
}


function getStatusTagType(status) {
  if (status == 1000) {
    return 'danger';
  }
  if (status == 2000) {
    return 'warning';
  }
  if (status == 3000) {
    return 'primary';
  }
  if (status == 6000) {
    return 'success';
  }
  if (status == 9000) {
    return 'info';
  }
  return 'info'
}


function getAfterSaleStatusTagType(status) {
  if (status == 0) {
    return 'danger';
  }
  if (status == 100) {
    return 'primary';
  }
  if (status == 200) {
    return 'warning';
  }
  if (status == 300) {
    return 'primary';
  }
  if (status == 600) {
    return 'success';
  }
  if (status == 900) {
    return 'info';
  }
  return 'info'
}

function afterSaleOrderStatusFormat(type, action, val) {
  if (val == null || val == undefined)
    return '';
  //退货已收到/服务已派单
  if (val == 300) {
    if (type == 0) {
      return '收到退货'
    }
    if (type == 1) {
      return '已派单'
    }
  }
  //已退款. 已重新发货/已重新安装
  if (val == 400) {
    if (type == 0) {
      //退货
      if (action == 300)
        return '已退款'
      else
        return '已发货'
    }
    if (type == 1) {
      return '已施工'
    }
  }
  return config.afterSalesStatus.find((r) => r.value === val || r.key === val).name;
}

function afterSaleActionFormat(val) {
  if (val == null || val == undefined)
    return '';
  return config.afterSaleAction.find((r) => r.value === val || r.key === val).name;
}

function afterSaleReasonFormat(val) {
  if (val == null || val == undefined)
    return '';
  return config.afterSaleReason.find((r) => r.value === val || r.key === val).name;
}
export default {
  boolFormat,
  dateTimeFormat,
  dateFormat,
  timeStringFormat,
  timespantodatetime,
  checkNumber,
  getFileType,
  responseUrlFormat,
  organizationTypeFormat,
  positionFormat,
  genderFormat,
  ScheduleTypeFormat,
  RunningModeFormat,
  LoggingLevelFormat,

  paymentModeFormat,
  paymentStatusFormat,
  paymentPurposeFormat,
  getPaymentStatusTag,

  productShelfStatusFormat,
  orderStatusFormat,
  orderDetailStatusFormat,
  getStatusTagType,

  afterSaleReasonFormat,
  getAfterSaleStatusTagType,
  afterSaleOrderStatusFormat,
  afterSaleActionFormat,

  formatDate,
}
